import { sendRequest } from './index';
import { API_TOOLKITS_URL } from '@core/constants/API';

export const GetToolkitCategories = () => {
	return sendRequest({
		url: `${API_TOOLKITS_URL}categories`,
		method: 'GET'
	});
};

export const GetToolkits = (params = {}) => {
	const cleanParams = Object.keys(params).reduce((acc, key) => {
		const value = params[key];
		if (value !== undefined && value !== null && value !== '') {
			acc[key] = value;
		}
		return acc;
	}, {});
	return sendRequest({
		url: `${API_TOOLKITS_URL}`,
		method: 'GET',
		params: cleanParams
	});
};

export const GetToolkit = (id) => {
	return sendRequest({
		url: `${API_TOOLKITS_URL}${id}`,
		method: 'GET'
	});
};

export const DownloadToolkit = (id) => {
	return sendRequest({
		url: `${API_TOOLKITS_URL}${id}/download`,
		method: 'GET'
	});
};

export const PurchaseToolkit = (id) => {
	return sendRequest({
		url: `${API_TOOLKITS_URL}${id}/purchase`,
		method: 'GET'
	});
};
